module.exports = __webpack_public_path__ + "static/media/design4.644884e5.png";